<template>
  <section class="wrapper">
    <div class="card">
      <ul>
        <li>
          <label><i class="iconfont icondetail-jilu"></i>会议名称</label>
          <span>{{meeting.activityTitle}}</span>
        </li>
        <li>
          <label><i class="iconfont iconcalendar"></i>开始时间</label>
          <span>{{startDate}}</span>
        </li>
        <li>
          <label><i class="iconfont iconcalendar"></i>结束时间</label>
          <span>{{endDate}}</span>
        </li>
        <li class="speakerItem" v-if=" meeting.speakerInfo.length >= 1">
          <label><i class="iconfont iconrenyuan"></i>主 讲 人</label>
          <span>
            <span>{{meeting.speakerInfo[0].speakerName}}</span>
            <span>{{meeting.speakerInfo[0].hospitalName}}
              <span v-if="meeting.speakerInfo && meeting.speakerInfo.length >1" @click="toggleHandler">
                <i  v-if="isShow" class="iconfont iconsort-down"></i>
                <i v-else class="iconfont iconsort-up"></i>
              </span>
            </span>
          </span>
        </li>
        <li v-if="meeting.speakerInfo.length==0">
          <label><i class="iconfont iconrenyuan"></i>主 讲 人</label>
          <span>无</span>
        </li>
        <li class="speakerItem" v-for="(item,index) in meeting.speakerInfo" :key="index"  v-if="index > 0 && isShow"  >
            <span>
              <span>{{item.speakerName}}</span>
              <span>{{item.hospitalName}}</span>
            </span>
        </li>
        <li>
          <span style="color:red" v-if="this.meeting.speakerInfo">主讲人不分先后顺序</span>
        </li>
      </ul>
    </div>
    <div class="card-detail">
      <p>会议详情</p>
      <dl>
        <dt>会议简介</dt>
        <dd>{{meeting.activityContent}}</dd>
      </dl>
      <div>
        <button v-if="showJoin" @click="joinHandler(meeting.attendMeetingUrl)">参会</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      meetingId:'',
      meeting:{
        activityTitle:'',
        activityContent:'',
        startDate:'',
        endDate:'',
        emsGuid:'',
        speakerInfo:[{
          speakerName:'',
          hospitalName:'',
        }
        ],
      },
    };
  },
  mounted() {
    console.log(process.env.config.seviceUrl, 'process.env.config.seviceUrl')
    if (process.env.config.seviceUrl.indexOf('wechatweb.takeda.com.cn') > -1) {
      document.title = '吾医空间'
    } else {
      document.title = '吾医空间测试号'
    }
     this.meetingId=this.$route.params.id;
        if(this.meetingId){
            this.getDetail();
        }
  },
  computed: {
    startDate(){
      var date=new Date(this.meeting.startDate.replace(/-/g,"/"))
      var str1=`${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`
      var str2= date.toLocaleTimeString("en-US").replace(/:[0-9][0-9](\s)/, " ");
      return str1+str2;

    },
    endDate(){
      var date=new Date(this.meeting.endDate.replace(/-/g,"/"))
      var str1=`${date.getFullYear()}年${date.getMonth()+1}月${date.getDate()}日`
      var str2= date.toLocaleTimeString("en-US").replace(/:[0-9][0-9](\s)/, " ");
      return str1+str2;
    },
    showJoin(){
      let current=new Date();
      let meetEnd = new Date(this.meeting.endDate.replace(/-/g, "/"))
      if(current>meetEnd){
        return false;
      }
      return true;
    }
  },
  methods: {
    toggleHandler() {
      this.isShow = !this.isShow;
    },
    getDetail(){
       this.$axiox.get(`/api/hcp/GetCalendarMeetingDetail?emsGuid=${this.meetingId}`).then(rsp => {
         Object.assign(this.meeting,rsp);
         this.meeting.speakerInfo=this.meeting.speakerInfo.filter(item=>{
          return item.speakerName.length>0&&item.hospitalName.length>0
         })
       });
    },
    joinHandler(url) {
      if (url) {
        window.location.href = url
      } else {
        this.$commonJs.showTips('暂无参会链接')
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  background: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  *:not(.iconfont) {
    font-family: 'source' !important;
  }
  .card {
    box-shadow: #e1e1e1 0 0 10px;
    margin: 15px;
    > ul {
      padding:10px 20px;
      font-size: 12px;
      line-height: 2em;
      list-style: none;
      max-height: 400px;
      overflow: auto;
      > li {
        position: relative;
        padding-left: 35%;
        min-height: 2em;
        overflow-wrap: break-word;
        label {
          display: inline-block;
          position: absolute;
          left: 0;
          top: 0;
          width: 35%;
          color: black;
          font-weight: 600;
          > .iconfont {
            color: #979797;
            font-size: 18px!important;
            vertical-align: bottom;
            margin-right: 10px;
          }
        }
        >span{
          vertical-align: baseline !important;
          display:inline-block !important;
        }
      }
      > li:first-child,
      > li:nth-child(3) {
        border-bottom: 1px dashed #dbdbdb;
      }
      >.speakerItem{
        >span{
            position: relative;
            padding-left: 32%;
            min-height: 2em;
            overflow-wrap: break-word;
            >span:first-child{
              display: inline-block;
              position: absolute;
              left: 0;
              top: 0;
              width: 32%;
            }
            >span:nth-child(2){
              display:inline-block !important;
              vertical-align: baseline;
              >span>.iconfont{
                font-size: 18px !important;
                text-align: center;
                color: #979797;
              }

            }
        }
      }
    }
  }
  .card-detail {
    padding-bottom: 20px;
    box-shadow: #e1e1e1 0 0 10px;
    margin: 15px;
    display: flex;
    flex-direction: column;
    > p {
      margin: 0 20px;
      font-size: 16px;
      color: red;
      font-weight: bolder;
      position: relative;
      line-height: 3em;
      &::after {
        content: "";
        display: inline-block;
        width: 8px;
        height: 3em;
        background-color: red;
        position: absolute;
        left: -20px;
      }
    }
    > dl {
      margin: 0 20px;
      > dt {
        font-weight: 600;
      }
      > dd {
        margin-left: 0px;
        max-height: 35vh;
        overflow-y: auto;
        text-align: justify;
        &::-webkit-scrollbar-thumb {
          -webkit-box-shadow: inset 0 0 5px !important;
          background:white !important;
          color:#ccc;
        }
        &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px white !important;
          background: white !important;
        }
      }
    }
    > div {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      > button {
        border-radius: 5px;
        padding: 0 0.6rem;
        height: 30px;
        letter-spacing: 2px;
        background-color: red;
        border: 2px solid red;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/meetingDetail.vue